import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  pickedUpShipmentsGroupedByDateRangeType,
  carrierSpend
} from '../../graphQL/queries/shipmentQueries';
import { withApollo } from 'react-apollo';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import LoadingIndicator from '../../components/LoadingIndicator';
import LineChart from '../../components/Global/Graphs/LineChart';
import DoughnutChart from '../../components/Global/Graphs/DonutChart';
import DonutLegend from '../../components/Global/Graphs/DonutLegend';
import * as Queries from '../../graphQL/queries/shipmentQueries';

import { AppContext } from '../../AppProvider';
import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import { styles as DashboardStyles } from './Dashboard.styles';
import DashboardHeader from '../../components/dashboard/Header';
import TimespanSelector from '../../components/Global/Graphs/TimespanSelector';
import {
  YEAR,
  MONTH,
  WEEK,
  DATE_RANGE_TYPE_DAY_OF_WEEK,
  DATE_RANGE_TYPE_WEEK,
  DATE_RANGE_TYPE_MONTH,
  DASHBOARD_MAX_CARRIERS,
  SHIPMENT_STATUS,
  SHIPMENT_IN_TRANSIT_STATUS
} from '../../constants/constants';
import moment from 'moment';
import currency from 'currency.js';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';

export class Dashboard extends Component {
  state = {
    user: {},
    loading: true,
    error: null,
    pickedUpShipments: {
      startDate: moment().startOf('year'),
      endDate: moment().endOf('year'),
      increment: YEAR,
      labels: [],
      data: []
    },
    carriers: {
      shipments: [],
      spend: [],
      startDate: moment().startOf('year'),
      endDate: moment().endOf('year'),
      increment: YEAR,
      labels: [],
      totalSpend: '',
      totalShipments: ''
    }
  };

  async componentDidMount() {
    const { client: ApolloClient } = this.props;

    const {
      orgInfo: { orgId }
    } = this.context.globalProps;

    try {
      this.getPickedUpShipments();
      this.getTopCarriers();

      const {
        data: {
          shipment: { byStatus: savedShipments }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: { shipmentStatusId: SHIPMENT_STATUS.SAVED, orgId: orgId }
      });

      const {
        data: {
          shipment: { byStatus: readyToTenderShipments }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: {
          shipmentStatusId: SHIPMENT_STATUS.READY_TO_TENDER,
          orgId: orgId
        }
      });

      const {
        data: {
          shipment: { byStatus: tenderRejectedShipments }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: {
          shipmentStatusId: SHIPMENT_STATUS.TENDER_REJECTED,
          orgId: orgId
        }
      });

      const {
        data: {
          shipment: { byStatus: autoTenderTransientFailureShipments }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: {
          shipmentStatusId: SHIPMENT_STATUS.AUTO_TENDER_TRANSIENT_FAILURE,
          orgId: orgId
        }
      });

      const {
        data: {
          shipment: { byStatus: autoTenderPermanentFailureShipments }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: {
          shipmentStatusId: SHIPMENT_STATUS.AUTO_TENDER_PERMANENT_FAILURE,
          orgId: orgId
        }
      });

      const incompleteShipmentCounter =
        savedShipments +
        readyToTenderShipments +
        tenderRejectedShipments +
        autoTenderTransientFailureShipments +
        autoTenderPermanentFailureShipments;

      const {
        data: {
          shipment: { byStatus: waitingForPickupShipmentCounter }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: {
          shipmentStatusId: SHIPMENT_STATUS.WAITING_FOR_PICKUP,
          orgId: orgId
        }
      });

      const {
        data: {
          shipment: { byStatus: inTransitShipmentCounter }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByStatus,
        variables: {
          shipmentStatusId: SHIPMENT_STATUS.IN_TRANSIT,
          orgId: orgId
        }
      });

      const {
        data: {
          shipment: { byInTransitStatus: delayedShipmentCounter }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentByInTransitStatus,
        variables: {
          shipmentInTransitStatusId: SHIPMENT_IN_TRANSIT_STATUS.DELAYED,
          orgId: orgId
        }
      });

      const {
        data: {
          shipment: { count: totalShipmentCounter }
        }
      } = await ApolloClient.query({
        query: Queries.shipmentCount,
        variables: { orgId: orgId }
      });

      this.setState({
        incompleteShipmentCounter,
        waitingForPickupShipmentCounter,
        inTransitShipmentCounter,
        delayedShipmentCounter,
        totalShipmentCounter
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  }
  _handleDateChange = (graphName, dates) => {
    const field = this.state[graphName];
    field.startDate = dates.startDate;
    field.endDate = dates.endDate;
    //requery graph
    this.setState({ [graphName]: field });

    if (graphName === 'pickedUpShipments') {
      this.getPickedUpShipments();
    } else {
      this.getTopCarriers();
    }
  };
  _handleIncrementChange = (graphName, increment) => {
    const field = this.state[graphName];

    field.increment = increment;
    field.startDate = field.startDate.startOf(increment);
    field.endDate = moment(field.startDate).endOf(increment);
    this.setState({ [graphName]: field });
    if (graphName === 'pickedUpShipments') {
      this.getPickedUpShipments();
    } else {
      this.getTopCarriers();
    }
  };

  async getPickedUpShipments() {
    const { client: ApolloClient } = this.props;
    const { pickedUpShipments } = this.state;
    const { orgId } = this.context.globalProps.orgInfo;

    // Determine the DateRangeType that we want the
    // server to break the data down by
    let dateRangeType = '';
    switch (pickedUpShipments.increment) {
      case YEAR:
      default:
        dateRangeType = DATE_RANGE_TYPE_MONTH;
        break;
      case MONTH:
        dateRangeType = DATE_RANGE_TYPE_WEEK;
        break;
      case WEEK:
        dateRangeType = DATE_RANGE_TYPE_DAY_OF_WEEK;
        break;
    }

    try {
      const {
        data: {
          shipment: {
            pickedUpShipmentsGroupedByDateRangeType: {
              data: pickedUpShipmentsResultData
            }
          }
        }
      } = await ApolloClient.query({
        query: pickedUpShipmentsGroupedByDateRangeType,
        variables: {
          orgId,
          dateRangeType: dateRangeType,
          startDate: pickedUpShipments.startDate.format('YYYY-MM-DD'),
          endDate: pickedUpShipments.endDate.format('YYYY-MM-DD')
        },
        fetchPolicy: 'network-only'
      });

      // Get Labels and Values for the graph
      pickedUpShipments.labels = pickedUpShipmentsResultData.map(ps => {
        return ps.Key;
      });
      pickedUpShipments.data = pickedUpShipmentsResultData.map(ps => {
        return ps.Value;
      });

      this.setState({
        pickedUpShipments
      });
    } catch (error) {
      this.setState({ error });
    }
  }
  async getTopCarriers() {
    const { t, client: ApolloClient } = this.props;
    const { carriers } = this.state;
    const { orgId } = this.context.globalProps.orgInfo;
    const formattedData = [];

    try {
      const {
        data: {
          carrier: { carrierSpend: carrierSpendData }
        }
      } = await ApolloClient.query({
        query: carrierSpend,
        variables: {
          orgId,
          dateFrom: carriers.startDate.format('YYYY-MM-DD'),
          dateTo: carriers.endDate.format('YYYY-MM-DD')
        },
        fetchPolicy: 'network-only'
      });

      // Separate the top Carriers and group the remaining in Other
      carrierSpendData.forEach((carrier, index) => {
        if (index < DASHBOARD_MAX_CARRIERS) {
          formattedData.push(carrier);
        } else if (index === DASHBOARD_MAX_CARRIERS) {
          formattedData.push({
            carrierName: t('Other'),
            totalShipments: carrier.totalShipments,
            totalSpend: carrier.totalSpend
          });
        } else {
          formattedData[DASHBOARD_MAX_CARRIERS].totalShipments +=
            carrier.totalShipments;
          formattedData[DASHBOARD_MAX_CARRIERS].totalSpend +=
            carrier.totalSpend;
        }
      });

      // Get Labels and Values for the graph
      carriers.labels = formattedData.length
        ? formattedData.map(c => {
            return c.carrierName;
          })
        : [t('Other')];
      carriers.shipments = formattedData.length
        ? formattedData.map(c => {
            return c.totalShipments;
          })
        : [1];
      carriers.spend = formattedData.length
        ? formattedData.map(c => {
            return c.totalSpend;
          })
        : [1];

      carriers.totalShipments = formattedData.length
        ? carriers.shipments.reduce((total, shipments) => {
            return total + shipments;
          }, 0)
        : '0';
      carriers.totalSpend = formattedData.length
        ? carriers.spend.reduce((total, spend) => {
            return total + spend;
          }, 0)
        : '0';
      this.setState({ carriers });
    } catch (error) {
      this.setState({ error });
    }
  }
  render() {
    const { t, classes, theme } = this.props;
    const { loading, pickedUpShipments, carriers } = this.state;
    const { branding } = this.context.globalProps;
    const donutColors = [
      '#FEB00B',
      _get(branding, 'frontendPrimaryDarkerColor', '#0053A7'),
      _get(branding, 'frontendPrimaryColor', '#00A1FB'),
      _get(branding, 'frontendSecondaryLightColor', '#E0F4FF'),
      _get(branding, 'frontendPrimaryLightColor', '#F2FAFF')
    ];
    const carrierSpendFormatted = currency(carriers.totalSpend, {
      symbol: '$',
      formatWithSymbol: true
    }).format();

    if (loading) {
      return <LoadingIndicator />;
    }

    return (
      <Fragment>
        <div className={classnames(classes.titleRootWrapper, classes.title)}>
          <h1 className={classes.headline4}>{t('Dashboard')}</h1>
        </div>
        <DashboardHeader
          incompleteShipmentCounter={this.state.incompleteShipmentCounter}
          waitingForPickupShipmentCounter={
            this.state.waitingForPickupShipmentCounter
          }
          inTransitShipmentCounter={this.state.inTransitShipmentCounter}
          delayedShipmentCounter={this.state.delayedShipmentCounter}
          totalShipmentCounter={this.state.totalShipmentCounter}
        />
        <Grid
          container
          justify="center"
          spacing={8}
          className={classes.chartsRow}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            classes={{
              item: classnames(classes.gridItem, classes.pickedUpShipmentsGraph)
            }}
            className={classes.wrapper}
          >
            <h2 className={classnames(classes.headline7, classes.graphTitle)}>
              {t('Shipments')}
            </h2>
            <TimespanSelector
              onIncrementChange={this._handleIncrementChange}
              increment={pickedUpShipments.increment}
              startDate={pickedUpShipments.startDate}
              endDate={pickedUpShipments.endDate}
              graphName={'pickedUpShipments'}
              onDateChange={this._handleDateChange}
            />
            <div>
              <LineChart
                data={pickedUpShipments.data}
                labels={pickedUpShipments.labels}
                backgroundColor={theme.palette.secondary.light}
                borderColor={theme.palette.primary.main}
                pointBackgroundColor={theme.palette.primary.main}
                pointHoverBackgroundColor={theme.palette.primary.main}
                pointHoverBorderColor={theme.palette.secondary.light}
              />
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={6}
            classes={{
              item: classnames(classes.gridItem, classes.topCarrierGraph)
            }}
            className={classnames(classes.wrapper)}
          >
            <h2 className={classnames(classes.headline7, classes.graphTitle)}>
              {t('Top Carriers')}
            </h2>
            <TimespanSelector
              onIncrementChange={this._handleIncrementChange}
              increment={carriers.increment}
              startDate={carriers.startDate}
              endDate={carriers.endDate}
              onDateChange={this._handleDateChange}
              graphName={'carriers'}
            />
            <Grid
              container
              justify="center"
              spacing={8}
              className={classes.donutGraph}
            >
              <Grid item xs={12} lg={4}>
                <DoughnutChart
                  data={carriers.shipments}
                  labels={carriers.labels}
                  colors={donutColors}
                  innerTitle={t('Shipments')}
                  innerText={carriers.totalShipments.toString()}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <DoughnutChart
                  data={carriers.spend}
                  labels={carriers.labels}
                  colors={donutColors}
                  innerTitle={t('Spend')}
                  innerText={carrierSpendFormatted}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <DonutLegend labels={carriers.labels} colors={donutColors} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

Dashboard.contextType = AppContext;
const DashboardWithTranslations = withNamespaces()(withApollo(Dashboard));
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, DashboardStyles),
  {
    withTheme: true
  }
)(DashboardWithTranslations);
